import AWS from 'aws-sdk'
import axios from 'axios'
import imageCompression from 'browser-image-compression'
import { enqueueSnackbar } from 'notistack'

export function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error)
            return
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject)
        }, interval)
      })
  })
}

export function capitalizeFirstLetter(string) {
  if (typeof string !== 'string') {
    return ''
  }
  return string.charAt(0).toUpperCase() + string.slice(1)
}

let instance

export const S3Upload = (file, token, identityId) => {
  return new Promise((resolve, reject) => {
    AWS.config.update({
      region: process.env.REACT_APP_REGION,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        IdentityId: identityId,
        Logins: {
          'cognito-identity.amazonaws.com': token,
        },
      }),
    })

    const S3Client = new AWS.S3()

    const date = new Date()
    const params = {
      Bucket: process.env.REACT_APP_BUCKET_NAME,
      // Using the date.getTime() method for a unique name;
      // however, you may want to consider alternative methods to avoid reliance on this approach.
      Key: `${
        process.env.REACT_APP_S3_MODE
      }/library/images/IMG_${date.getTime()}.jpg`,
      Body: file,
      ContentType: 'image/jpeg',
    }

    instance = S3Client.upload(params, function (err, data) {
      if (err) {
        instance = undefined
        console.error('Error uploading file:', err)
        reject(err)
      }
      saveFilePath(data?.Location)
      instance = undefined
      resolve({ ...data, name: file.name })
    })
  })
}

export const CompressImage = async (file) => {
  const options = {
    maxSizeMB: 1,
    useWebWorker: true,
    fileType: 'image/jpeg',
  }
  try {
    const compressedFile = await imageCompression(file, options)
    return compressedFile
  } catch (error) {
    console.log(error)
    enqueueSnackbar('Something went wrong', { variant: 'error' })
    return
  }
}

const saveFilePath = (path) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
    if (path) {
      axios.post(
        `${process.env.REACT_APP_ADMIN_API_URL}/file-url/store`,
        { path },
        config,
      )
    }
  } catch (error) {
    console.log(error)
  }
}

export const S3Delete = (path, token, identityId) => {
  return new Promise((resolve, reject) => {
    AWS.config.update({
      region: process.env.REACT_APP_REGION,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        IdentityId: identityId,
        Logins: {
          'cognito-identity.amazonaws.com': token,
        },
      }),
    })

    const S3Client = new AWS.S3()

    const params = {
      Bucket: process.env.REACT_APP_BUCKET_NAME,
      Key: `${
        process.env.REACT_APP_S3_MODE +
        path?.split(process.env.REACT_APP_S3_MODE)[1]
      }`,
    }

    S3Client.deleteObject(params, function (err, data) {
      if (err) {
        console.error('Error deleting file:', err)
        reject(err)
      }
      resolve()
    })
  })
}

export const S3Abort = () => {
  if (instance) {
    try {
      instance.abort()
    } catch (error) {
      console.log(error)
    }
  }
}
